import { Types } from 'mongoose';
import { IAccountOwned } from './account';

export interface IEnquiry extends IAccountOwned {
  _id: Types.ObjectId;
  name: string;
  email: string;
  phone: string;
  message: string;
  status: EnquiryStatus;
  created_on: Date;
}

export enum EnquiryStatus {
  Open = 'open',
  Closed = 'closed',
}
